module.exports = __webpack_public_path__ + "img/upkot-old-logo.2bfe90e5.svg";